import { styled } from 'styled-components';

// Wrapper for all buttons
export const Ul = styled.ul`
  align-items: center;
  display: inline-flex;
  margin-right: var(--spacing-small);
`;

// A single button's wrapper
export const Li = styled.li`
  &:not(:last-child) {
    margin-right: var(--spacing-small);
  }

  button {
    border-radius: var(--border-radius-huge);
  }
`;
